import { UNIT_API } from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { apiClient } from "shared/plugins/http-service";
import { UnitModel } from "./unit.models";

export const getUnitList = async () => {
  return await apiClient.getHttp<UnitModel[]>(`${UNIT_API}`);
};

export const removeUnit = async (removedModel: RemovedEntityModel<number>) => {
  const response = await apiClient.postHttp(
    `${UNIT_API}/remove_list`,
    removedModel
  );
  return response;
};

export const getUnitById = async (id: number) => {
  return await apiClient.getHttp<UnitModel>(`${UNIT_API}/${id}`);
};

export const addUnit = async (model: UnitModel) => {
  const response = await apiClient.postHttp<number>(`${UNIT_API}`, model);
  return response;
};

export const updateUnit = async (model: UnitModel) => {
  const response = await apiClient.putHttp<number>(`${UNIT_API}`, model);
  return response;
};
